<gs1-loading></gs1-loading>

@if (inscriptionComplete()) {
  <header-comp></header-comp>
  <app-side-menu></app-side-menu>
}

<app-page [class.with-side-menu]="inscriptionComplete()">
  <router-outlet></router-outlet>
</app-page>

@if (!isFederation()) {
  <footer-comp></footer-comp>
}
